import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import UserRating from "../../FlowComponents/UserRating";

import { updateMetaToSocket } from "../../../services/socket";
import { addInstallation } from "../../../services/saveResponse";
import { getDynamicFont, scroll } from "../../../services/shared";
import { initializeLauncherIcon } from "../../../utilities/MessengerInitializer";
import { botAppearanceSound } from "../../../services/notification-handler";
import FooterControls from "../FooterControls";
import Chat from "../../Chat";
import KnowledgeBase from "../../KnowledgeBase";
import Tickets from "../../Tickets";
import SkeltonLoader from "../SkeltonLoader";
import ResizableBox from "../../ResizableBox";

/**
 * Author: Divyansh
 * Date: 1 Feb 2024
 * Description: Layout component is used to render the layout of the application. UI have 4 components:
 * Heading that will only be applicable for chat window and not for landing pages
 * ChatBlock will be always visible
 * UserInput will be always visible but will change based on the flow question
 * PoweredBy will be when enabled by agency and will be hidden if window is whitelabelled
 */

export default function LauncherIconHandler() {

  const [loader, setLoader] = useState(true);

  const design = useSelector((state: any) => state?.design);
  const messages = useSelector((state: any) => state?.messages);
  const ratingScreen = useSelector((state: any) => state?.ratingScreen);
  const configuration = useSelector((state: any) => {
    return state && state.configuration
      ? state.configuration
      : undefined
  });
  const activeTab: 'Chat' | 'Knowledge Base' | 'Tickets' = useSelector((state: any) => state && state.footerTab);

  const [initialState, setInitialState] = useState({
    currentPath: window.location.pathname,
    start: false,
    shouldFetchData: false
  })


  useEffect(() => {
    initializeLauncherIcon();
    setLoader(false);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (design?.fontFamilyLink) {
        getDynamicFont(design?.fontFamilyLink);
      }

      let frame = window.parent.document.getElementById('BotPenguin-messenger');
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          scroll();
        });
      });

      if (frame) {
        observer.observe(frame, { attributes: true, attributeFilter: ['style'] });
      }

      localStorage.setItem('questions', JSON.stringify([]));
    }, 100)

    return () => clearTimeout(timer);

  }, [design]);

  useEffect(() => {

    const messageHandler = (event: any) => {
      if (event.data.origin === 'BotPenguin') {
        if (event.data.action === 'start') {
          scroll();
          if (!initialState.start && configuration) {
            botAppearanceSound(configuration.generalSettings.notificationSound);
          }

          if (!messages.length && !initialState.start) {
            setInitialState({
              ...initialState,
              start: true
            });
            // renderQuestion();
            updateMetaToSocket();
            addInstallation();
          }
          setInitialState({
            ...initialState,
            shouldFetchData: true
          });
        }
      }
    }

    window.addEventListener('message', messageHandler);

    // Cleanup function
    return () => {
      window.removeEventListener('message', messageHandler);
    };
  });

  const isEnabled = (type: 'knowledgeBase' | 'tickets'): boolean => {
    switch (type) {
      case "knowledgeBase":
        return !!configuration && configuration.chatMenu && configuration.chatMenu.knowledgeBase?.enabled;
      case "tickets":
        return !!configuration && configuration.chatMenu && configuration.chatMenu.ticketing?.enabled;
      default:
        return false;
    }
  }

  return (
    <>
      {
        !!ratingScreen
          ? <UserRating />
          : <>
            {
              !loader
                ? (
                  <ResizableBox>
                    {activeTab === 'Chat' &&
                      <div id='ele-3' className="h-dvh flex flex-col">
                        <div id='ele-4' className="flex-grow overflow-y-auto hide-scrollbar relative w-100"><Chat design={design} shouldFetchData={initialState.shouldFetchData} /></div>
                        {
                          (isEnabled("knowledgeBase") || isEnabled('tickets')) &&
                          <div id='ele-5' className="h-24 min-h-24"><FooterControls /></div>
                        }
                      </div>
                    }

                    {activeTab === 'Knowledge Base' &&
                      <div id='ele-6' className="h-dvh flex flex-col">
                        <div id='ele-7' className="flex-grow overflow-y-auto hide-scrollbar"><KnowledgeBase design={design} /></div>
                        {
                          (isEnabled("knowledgeBase") || isEnabled('tickets')) &&
                          <div id='ele-8' className="h-24 min-h-24"><FooterControls /></div>
                        }
                      </div>
                    }

                    {activeTab === 'Tickets' &&
                      <div id='ele-9' className="h-dvh flex flex-col">
                        <div id='ele-10' className="flex-grow overflow-y-auto hide-scrollbar"><Tickets design={design} /></div>
                        {
                          (isEnabled("knowledgeBase") || isEnabled('tickets')) &&
                          <div id='ele-11' className="h-24 min-h-24"><FooterControls /></div>
                        }
                      </div>
                    }
                  </ResizableBox>
                )
                : <>
                  <SkeltonLoader />
                </>
            }
          </>
      }
    </>
  )
}
